import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-shield-check-icon',
  templateUrl: './general-shield-check.component.html'
})
export class GeneralShieldCheckComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
